import React from "react";
import * as Shared from "../components/CivicShared";

const { SimplePage, FileText, Search, MapPin, ArrowRight, CIVIC_CATEGORIES } = Shared;

export default function ComplaintsPage({ onBack, go }) {
  return (
    <SimplePage title="Vijayanagar Complaints & Civic Issues" onBack={onBack}>
      <section className="complaints-seo-page">
        <p className="lead">
          Residents of Vijayanagar, Bengaluru can use the Vijayanagar Civic Portal to report local civic complaints, follow complaint progress and find public information about wards and civic services.
        </p>

        <div className="hero-buttons">
          <button className="civic-btn primary" onClick={() => go("/report-issue")}>
            <FileText size={17} />
            Report a Civic Complaint
            <ArrowRight size={16} />
          </button>
          <button className="civic-btn secondary" onClick={() => go("/track-complaint")}>
            <Search size={17} />
            Track a Complaint
          </button>
        </div>

        <section>
          <h2>What civic complaints can residents report?</h2>
          <p>
            The portal supports common local civic concerns across Vijayanagar, including roads and potholes, water supply, drainage, garbage and waste, street lights, parks and public spaces, schools, health services, traffic and parking, stray animals, encroachment and sanitation.
          </p>
          <div className="complaint-category-grid">
            {CIVIC_CATEGORIES.map((category) => (
              <div className="complaint-category-card" key={category}>
                <MapPin size={17} />
                <span>{category}</span>
              </div>
            ))}
          </div>
        </section>

        <section>
          <h2>How to report a complaint in Vijayanagar</h2>
          <ol className="complaint-steps">
            <li><strong>Choose the issue category.</strong> Select the type of civic problem that best describes the issue.</li>
            <li><strong>Select the ward and location.</strong> Provide the relevant ward, address and landmark so the issue can be understood clearly.</li>
            <li><strong>Describe the problem.</strong> Add useful details and photographs where available.</li>
            <li><strong>Save your tracking ID.</strong> Use the complaint reference to follow status updates through the portal.</li>
          </ol>
        </section>

        <section>
          <h2>Vijayanagar ward and civic information</h2>
          <p>
            Complaints are connected with ward-level civic information so residents can explore public activity and understand the types of issues being reported in their area.
          </p>
          <button className="text-link" onClick={() => go("/wards")}>
            Explore Vijayanagar wards <ArrowRight size={15} />
          </button>
        </section>

        <section className="complaint-faq" aria-labelledby="complaint-faq-heading">
          <h2 id="complaint-faq-heading">Frequently asked questions about Vijayanagar complaints</h2>
          <article>
            <h3>How do I report a civic complaint in Vijayanagar?</h3>
            <p>Use the Report a Civic Complaint option, select the issue category and ward, describe the problem and submit the complaint through the portal.</p>
          </article>
          <article>
            <h3>How can I track my Vijayanagar complaint?</h3>
            <p>Use the Track a Complaint option and enter the complaint tracking information provided after submission.</p>
          </article>
          <article>
            <h3>What types of local issues can I report?</h3>
            <p>You can report supported civic concerns such as potholes, roads, drainage, water supply, garbage, street lights, sanitation, parks and other local civic issues.</p>
          </article>
        </section>
      </section>
    </SimplePage>
  );
}
